export var TypeActionDependencyInjection;
(function (TypeActionDependencyInjection) {
    TypeActionDependencyInjection["Inject"] = "DependencyInjection > Inject";
})(TypeActionDependencyInjection || (TypeActionDependencyInjection = {}));
export var actionDependencyInjection = function (deps) { return ({
    deps: deps,
    type: TypeActionDependencyInjection.Inject,
}); };



//////////////////
// WEBPACK FOOTER
// ./src/features/dep-injection/actionDependencyInjection.ts
// module id = 827
// module chunks = 3